import { useT } from '../i18n';
import { Button } from '../components/Button/Button';
import { NetworkError } from '../lib/api/errors';
import { ChunkLoadError } from '../app/lazyScreen';
import { Header } from './Header';

/** The connection, not the app: a stage chunk or a call that never arrived. */
export const isOffline = (error: unknown) =>
  error instanceof ChunkLoadError ||
  error instanceof NetworkError ||
  (typeof navigator !== 'undefined' && navigator.onLine === false);

/**
 * Fallback for a crashed screen (and the router's errorElement). Offline (a stage that didn't
 * load, a failed call): "Try again" remounts the screen, which loads again; a reload would
 * show the browser's offline page. Anything else: reload. Copy is a DRAFT.
 */
export function ErrorScreen({ error, onReset }: { error?: unknown; onReset?: () => void }) {
  const t = useT();
  const offline = isOffline(error);
  return (
    <div className="screen" data-screen="error">
      <Header stage={null} />
      <main className="pane pane--nodock" role="alert">
        <h1 className="q">{t(offline ? 'common.error.offlineTitle' : 'common.error.title')}</h1>
        <p className="sub">{t(offline ? 'common.error.offlineBody' : 'common.error.body')}</p>
        <Button
          onClick={() => {
            onReset?.();
            if (!offline || !onReset) window.location.reload();
          }}
        >
          {t(offline ? 'common.error.retry' : 'common.error.reload')}
        </Button>
      </main>
    </div>
  );
}
